import React from 'react';
import { Alert } from 'antd';
import { TeamOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { PresenceScopeType, PresenceUser } from '../../modules/presence/api/presenceApi';

interface PresenceBannerProps {
  scopeType: PresenceScopeType;
  others: PresenceUser[];
  style?: React.CSSProperties;
}

/**
 * Soft warning that other people are working on the same thing right now.
 * Renders nothing when nobody else is present. Warns, never blocks.
 */
const PresenceBanner: React.FC<PresenceBannerProps> = ({ scopeType, others, style }) => {
  const { t } = useTranslation(['orders']);

  if (!others || others.length === 0) return null;

  const names = others.map((person) => person.userName).filter(Boolean);
  const firstName = names[0] || t('orders:presence.someone');
  const extra = others.length - 1;
  const who =
    extra > 0 ? t('orders:presence.whoMany', { name: firstName, extra }) : firstName;

  const message =
    scopeType === 'ORDER'
      ? t('orders:presence.hasOrderOpen', { who })
      : t('orders:presence.creatingForCustomer', { who });

  return <Alert type="warning" showIcon icon={<TeamOutlined />} message={message} style={style} />;
};

export default PresenceBanner;
